<template>
  <div>
    <div>
      <ColorPickerInput
        label="Background Color"
        :color="block.config.style.background.color"
        @input="
          UPDATE_BLOCK_PROP({
            id: block.id,
            prop: ['config', 'style', 'background', 'color'],
            value: $event,
          })
        "
      ></ColorPickerInput>
    </div>
    <BaseBlockBlobSelector :block="block"></BaseBlockBlobSelector>

    <ColorPickerInput
      label="Primary Text Color"
      :color="block.config.style.color.primary"
      @input="
        UPDATE_BLOCK_PROP({
          id: block.id,
          prop: ['config', 'style', 'color', 'primary'],
          value: $event,
        })
      "
    ></ColorPickerInput>
    <ColorPickerInput
      label="Secondary Text Color"
      :color="block.config.style.color.secondary"
      @input="
        UPDATE_BLOCK_PROP({
          id: block.id,
          prop: ['config', 'style', 'color', 'secondary'],
          value: $event,
        })
      "
    ></ColorPickerInput>
    <ColorPickerInput
      label="Link Color"
      :color="block.config.style.color.link"
      @input="
        UPDATE_BLOCK_PROP({
          id: block.id,
          prop: ['config', 'style', 'color', 'link'],
          value: $event,
        })
      "
    ></ColorPickerInput>
    <SliderInput
      label="Padding Top"
      :sliderValue="block.config.style.paddingTop"
      min="0"
      max="180"
      @change="
        UPDATE_BLOCK_PROP({
          id: block.id,
          prop: ['config', 'style', 'paddingTop'],
          value: $event,
        })
      "
    />
    <SliderInput
      label="Padding Bottom"
      :sliderValue="block.config.style.paddingBottom"
      min="0"
      max="180"
      @change="
        UPDATE_BLOCK_PROP({
          id: block.id,
          prop: ['config', 'style', 'paddingBottom'],
          value: $event,
        })
      "
    />
    <DividerStylePopup :block="block"></DividerStylePopup>
    <v-divider class="mt-3 mb-4"></v-divider>
    <v-switch
      v-model="block.config.style.hasTopBorder"
      label="Has Top Border"
      @change="
        UPDATE_BLOCK_PROP({
          id: block.id,
          prop: ['config', 'style', 'hasTopBorder'],
          value: $event,
        })
      "
      dense
      flat
      inset
    ></v-switch>
    <ColorPickerInput
      label="Top Border Color"
      v-if="block.config.style.hasTopBorder"
      :color="block.config.style.topBorderColor"
      @input="
        UPDATE_BLOCK_PROP({
          id: block.id,
          prop: ['config', 'style', 'topBorderColor'],
          value: $event,
        })
      "
    ></ColorPickerInput>
    <v-switch
      v-model="block.config.style.hasBottomBorder"
      label="Has Bottom Border"
      @change="
        UPDATE_BLOCK_PROP({
          id: block.id,
          prop: ['config', 'style', 'hasBottomBorder'],
          value: $event,
        })
      "
      dense
      flat
      inset
    ></v-switch>
    <ColorPickerInput
      label="Bottom Border Color"
      v-if="block.config.style.hasBottomBorder"
      :color="block.config.style.bottomBorderColor"
      @input="
        UPDATE_BLOCK_PROP({
          id: block.id,
          prop: ['config', 'style', 'bottomBorderColor'],
          value: $event,
        })
      "
    ></ColorPickerInput>
    <v-divider class="mt-3 mb-4"></v-divider>
    <h4>Responsive Options</h4>
    <v-switch
      v-model="block.config.style.hideOnDesktop"
      label="Hide On Desktop"
      @change="
        UPDATE_BLOCK_PROP({
          id: block.id,
          prop: ['config', 'style', 'hideOnDesktop'],
          value: $event,
        })
      "
      dense
      flat
      inset
    ></v-switch>
    <v-switch
      v-model="block.config.style.hideOnTablet"
      label="Hide On Tablet"
      @change="
        UPDATE_BLOCK_PROP({
          id: block.id,
          prop: ['config', 'style', 'hideOnTablet'],
          value: $event,
        })
      "
      dense
      flat
      inset
    ></v-switch>
    <v-switch
      v-model="block.config.style.hideOnMobile"
      label="Hide On Mobile"
      @change="
        UPDATE_BLOCK_PROP({
          id: block.id,
          prop: ['config', 'style', 'hideOnMobile'],
          value: $event,
        })
      "
      dense
      flat
      inset
    ></v-switch>
    <v-divider class="mt-3 mb-4"></v-divider>
    <v-btn text small outlined @click="copyStyleClick()">
      <v-icon left x-small>mdi-content-copy</v-icon>Copy Style
    </v-btn>
    <v-btn
      text
      small
      outlined
      @click="pasteStyleClick()"
      class="ml-2"
      :disabled="!tempCopiedStyle"
    >
      <v-icon left x-small>mdi-content-paste</v-icon>Paste Style
    </v-btn>
  </div>
</template>

<script>
import { mapMutations } from "vuex";
import projectMixin from "./../project-mixin";
import ColorPickerInput from "../../ColorPickerInput";
import DividerStylePopup from "./DividerStylePopup";
import BaseBlockBlobSelector from "./BaseBlockBlobSelector";
import SliderInput from "../../SliderInput";

export default {
  props: ["block"],
  components: {
    DividerStylePopup,
    ColorPickerInput,
    BaseBlockBlobSelector,
    SliderInput,
  },
  mixins: [projectMixin],
  methods: {
    ...mapMutations({
      COPY_STYLE: "project/COPY_STYLE",
    }),
    copyStyleClick() {
      this.COPY_STYLE(this.block.config.style);
    },
    pasteStyleClick() {
      if (this.tempCopiedStyle) {
        this.PASTE_STYLE();
      }
    },
  },
};
</script>

<style scoped>
.blob-type {
  cursor: pointer;
  transition: 200ms all;
  width: 100%;
  text-align: center;
  border: 1px solid transparent;
}
.blob-type:hover {
  background-color: #efefef;
}
.blob-type.active {
  border: 1px solid #292961;
}
</style>